import { Dropdown, Modal } from "antd";
import { FaTrash } from "react-icons/fa6";
import {
	DownOutlined,
	EditOutlined,
	PlusOutlined,
	StopOutlined,
	ToolOutlined,
} from "@ant-design/icons";
import Display from "../../Helpers/Table/Table Actions/Display";
import { useContext, useState } from "react";
import { popupcontext } from "../../../context/Popupscontext";
import trans from "../../../utils";
import Delete from "../../Helpers/Delete/DeletePopup";
import { useDispatch, useSelector } from "react-redux";
import { CiLogin } from "react-icons/ci";
import axios from "axios";
import { setUserInf } from "../../../Redux/service/Users/UsersSlice";
import { filtrationcontext } from "../../../context/Filtercontext";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../Helpers/Button/Button";
import usePermission from "../../../hooks/usePermission";

const Actions = ({
	vehicleId,
	DriverId,
	userId,
	subuserId,
	notifiyid,
	subcatid,
	GroupId,
	formId,
	type,
	poiId,
	request,
	name,
	imei,
	role,
	login,
	expired,
	technicianId,
	maintenanceId,
	permissionId,
	roleId,
	taskId,
	onClick,
	handleCancelRequest,
	setEditRequest,
	customerId,
	snagId,
	snagType, // ✅ NEW: snag type (INTERNAL/EXTERNAL)
	onEdit, // ✅ NEW: callback for snag edit
	irId,
	irStatus, // ✅ NEW: IR status to check if edit is allowed
	submittalId,
	companyId,
	setEditCompany,
	teamId,
	setEditTeam,
	onAssignProjects,
	canEdit,
	canDelete,
	canAddTask,
	assignrole,
	onDeactivateTeam,
	onActivateTeam,
	teamStatus,
	onDeactivateMember,
	onActivateMember,
	memberStatus,
	memberId,
	setEditMember,
	onGroupConnect,
	  onConfigShift,
	onAssignPois
}) => {
	console.log("traccarId", maintenanceId);
	const {
		handleShow,
		showDetails,
		setIsLinking,
		setActiveConnection,
		setActiveRole,
		setIsAssigning,
		continueSetup,
		setContinueSetup,
		setcurrentPOIId,
		setIsAssigningMemberToTeams,
		setActiveMemberForTeams,
		setIsAssigningMembersToTeam,
		setActiveTeamForMembers,
		setIsAssigningCompany,
		setActiveUserForCompany,
		setcurrentIRId,
		setOfflinePopup,
		offlinePopup,
		setIsEditing,
		setcurrentSnagId,
	} = useContext(popupcontext);
	let { setLoader } = useContext(filtrationcontext);
	let { pathname } = useLocation();
	const inf = useSelector((state) => state.users.user);
	// RBAC: users granted the "connections" permission can use the link action
	const { view: canConnections } = usePermission("CONNECTIONS");
	// RBAC: users granted POIS edit/add can use the Assign POIs action
	const { edit: canEditPois, create: canAddPois } = usePermission("POIS");
	const navigate = useNavigate();
	const [isDeactivateModalVisible, setIsDeactivateModalVisible] =
		useState(false);
	const [isActivateModalVisible, setIsActivateModalVisible] = useState(false);

	// ✅ NEW: Determine if user can edit this snag
	const canEditSnag = () => {
		if (type !== "snag") return false;

		const userRole = inf?.attributes?.role;

		// QA can only edit INTERNAL snags
		if (userRole === "qa" && snagType === "INTERNAL") {
			return true;
		}

		// Consultant can only edit EXTERNAL snags
		if (userRole === "consultant" && snagType === "EXTERNAL") {
			return true;
		}

		return false;
	};

	const handleDisplayClick = () => {
		if (vehicleId) showDetails("vehicles", vehicleId);
		else if (DriverId) showDetails("drivers", DriverId);
		else if (userId) {
			showDetails("users", userId);
		} else if (subuserId) showDetails("subusers", subuserId);
		else if (GroupId) showDetails("groups", GroupId);
		else if (notifiyid) showDetails("notifications", notifiyid);
		else if (technicianId) showDetails("technician", technicianId);
		else if (maintenanceId) showDetails("maintenance", maintenanceId);
		else if (formId) showDetails("form", formId);
		else if (taskId) showDetails("task", taskId);
		else if (poiId) showDetails("pois", poiId);
		else if (request?.id) showDetails("request", request?.id);
		else if (permissionId) showDetails("permission", permissionId);
		else if (roleId) showDetails("role", roleId);
		else if (customerId) showDetails("customer", customerId);
		else if (snagId) {
			if (type === "offlineMode") {
				setOfflinePopup(true);
				setcurrentSnagId(snagId);
			} else {
				showDetails("snag", snagId);
			}
		} else if (irId) {
			if (type === "offlineMode") {
				setOfflinePopup(true);
				setcurrentIRId(irId);
			} else {
				showDetails("IR", irId);
			}
		} else if (submittalId) showDetails("submittal", submittalId);
		else if (companyId) showDetails("company", companyId);
		else if (teamId) showDetails("team", teamId);
		else if (memberId) showDetails("member", memberId);
	};
	console.log("offlinePopup", offlinePopup);
	const handleEditClick = () => {
		if (vehicleId) {
			handleShow("editForm", "vehicles", vehicleId);
		}
		if (DriverId) {
			handleShow("editForm", "drivers", DriverId);
		}
		if (userId) {
			handleShow("editForm", "users", userId);
		}
		if (subuserId) {
			handleShow("editForm", "users", subuserId);
		}
		if (notifiyid) {
			handleShow("editForm", "notifications", notifiyid);
		}
		if (GroupId) {
			handleShow("editForm", "groups", GroupId);
		}
		if (technicianId) {
			handleShow("editForm", "technician", technicianId);
		}
		if (maintenanceId) {
			handleShow("editForm", "maintenance", maintenanceId);
		}
		if (formId) {
			navigate(`/forms/formbuilder/${formId}`);
		}
		if (taskId) {
			handleShow("editForm", "task", taskId);
		}
		if (poiId) {
			handleShow("editForm", "pois", poiId);
		}
		if (request?.id) {
			setEditRequest(request?.id);
		}
		if (permissionId) {
			handleShow("editForm", "permission", permissionId);
		}
		if (roleId) {
			handleShow("editForm", "role", roleId);
		}
		if (customerId) {
			handleShow("editForm", "customer", customerId);
		}
		if (irId) {
			handleShow("editForm", "IR", irId);
		}
		if (submittalId) {
			handleShow("editForm", "submittal", submittalId);
		}
		if (snagId && type === "snag" && onEdit) {
			onEdit(snagId);
		}
		if (companyId) {
			setEditCompany(companyId);
		}
		if (teamId) {
			setEditTeam(teamId);
		}
		if (memberId) {
			setEditMember(memberId);
		}
		if (memberId) {
			setEditMember(memberId);
		}
		if (irId && type === "offlineMode") {
			navigate(`/IR-offline-control/${irId}`);
		}
		if (snagId && type === "offlineMode") {
			navigate(`/snag-offline-control/${snagId}`);
		}
	};

	const handleDeleteClick = () => {
		if (DriverId) {
			handleShow("deleteItem", "drivers", DriverId);
		}
		if (vehicleId) {
			handleShow("deleteItem", "vehicles", vehicleId);
		}
		if (userId) {
			handleShow("deleteItem", "users", userId);
		}
		if (subuserId) {
			handleShow("deleteItem", "subusers", subuserId);
		}
		if (notifiyid) {
			handleShow("deleteItem", "notifications", notifiyid);
		}
		if (GroupId) {
			handleShow("deleteItem", "groups", GroupId);
		}
		if (technicianId) {
			handleShow("deleteItem", "technician", technicianId);
		}
		if (maintenanceId) {
			handleShow("deleteItem", "maintenance", maintenanceId);
		}
		if (formId) {
			handleShow("deleteItem", "form", formId);
		}
		if (taskId) {
			handleShow("deleteItem", "task", taskId);
		}
		if (poiId) {
			handleShow("deleteItem", "pois", poiId);
		}
		if (request?.id) {
			handleShow("deleteItem", "request", request?.id);
		}
		if (permissionId) {
			handleShow("deleteItem", "permission", permissionId);
		}
		if (roleId) {
			handleShow("deleteItem", "role", roleId);
		}
		if (customerId) {
			handleShow("deleteItem", "customer", customerId);
		}
		if (snagId && type === "snag") {
			handleShow("deleteItem", "snag", snagId);
		}
		if (companyId) {
			handleShow("deleteItem", "company", companyId);
		}
		if (teamId && type !== "team") {
			handleShow("deleteItem", "team", teamId);
		}
		if (irId) {
			handleShow("deleteItem", "IR", irId);
		}
		if (snagId) {
			handleShow("deleteItem", "snag", snagId);
		}
	};

	const handleDeactivateClick = () => {
		setIsDeactivateModalVisible(true);
	};

	const handleDeactivateConfirm = () => {
		if (onDeactivateTeam && teamId) {
			onDeactivateTeam(teamId);
			setIsDeactivateModalVisible(false);
		} else if (onDeactivateMember && memberId) {
			onDeactivateMember(memberId);
			setIsDeactivateModalVisible(false);
		}
	};

	const handleActivateClick = () => {
		setIsActivateModalVisible(true);
	};

	const handleActivateConfirm = () => {
		if (onActivateTeam && teamId) {
			onActivateTeam(teamId);
			setIsActivateModalVisible(false);
		} else if (onActivateMember && memberId) {
			onActivateMember(memberId);
			setIsActivateModalVisible(false);
		}
	};

	const handleConnectionsClick = async () => {
		setIsLinking(true);
		await setActiveConnection({
			id: checkIdType(),
			name,
			type: checkType(),
			role,
			imei,
		});
	};
	const handleAssignRoleClick = async () => {
		setIsAssigning(true);
		await setActiveRole({
			id: checkIdType(),
			name,
		});
	};

	const handleAssignMemberToTeamsClick = async () => {
		setIsAssigningMemberToTeams(true);
		setActiveMemberForTeams({
			id: memberId,
			name,
		});
	};

	const handleAssignMembersToTeamClick = async () => {
		setIsAssigningMembersToTeam(true);
		setActiveTeamForMembers({
			id: teamId,
			name,
		});
	};

	const handleAssignCompanyClick = async () => {
		setIsAssigningCompany(true);
		setActiveUserForCompany({
			id: memberId,
			name,
		});
	};
	const handleContinueSetup = async () => {
		navigate("/setup/project-setup-control");
		setContinueSetup(true);
		setcurrentPOIId(poiId);
	};
	const checkIdType = () => {
		if (vehicleId) {
			return vehicleId;
		} else if (userId) {
			return userId;
		} else if (subuserId) {
			return subuserId;
		} else if (roleId) {
			return roleId;
		}
	};

	const checkType = () => {
		if (vehicleId) {
			return "vehicles";
		} else if (userId) {
			return "users";
		} else if (subuserId) {
			return "subusers";
		}
	};

	const handleMenuClick = ({ key }) => {
		if (key === "link") handleConnectionsClick();
		if (key === "group-connect" && onGroupConnect) onGroupConnect();
		if (key === "edit") handleEditClick();
		if (key === "delete") handleDeleteClick();
		if (key === "deactivate") handleDeactivateClick();
		if (key === "activate") handleActivateClick();
		if (key === "login") quickLogin();
		if (key === "requestTask") onClick();
		if (key === "cancelrequest") handleCancelRequest(request?.id);
		if (key === "configShift" && onConfigShift) onConfigShift();
		if (key === "assignPois" && onAssignPois) onAssignPois();

		if (key === "assignrole") handleAssignRoleClick();
		if (key === "assignProjects" && onAssignProjects) onAssignProjects();
		if (key === "continuesetup") handleContinueSetup();
		if (key === "assignMemberToTeams") handleAssignMemberToTeamsClick();
		if (key === "assignMembersToTeam") handleAssignMembersToTeamClick();
		if (key === "assignCompany") handleAssignCompanyClick();
	};

	const dispatch = useDispatch();
	const body = new URLSearchParams();
	const twoDaysLater = new Date(
		Date.now() + 2 * 24 * 60 * 60 * 1000,
	).toISOString();

	body.append("expiration", twoDaysLater);

	const quickLogin = async () => {
		setLoader(true); // show loader immediately
		try {
			const id = userId || subuserId;
			if (!id) console.error("No user ID available");

			const [sessionRes, tokenRes] = await Promise.all([
				axios.get(`${process.env.REACT_APP_API_URL}/session/${id}`, {
					withCredentials: true,
				}),
				axios.post(
					`${process.env.REACT_APP_API_URL}/session/token`,
					body.toString(),
					{
						headers: { "Content-Type": "application/x-www-form-urlencoded" },
						withCredentials: true,
					},
				),
			]);

			if (!sessionRes.data || !tokenRes.data) {
				console.error("Invalid session or token response");
			}

			dispatch(setUserInf(sessionRes.data));
			localStorage.setItem("token", tokenRes.data);
			window.location.replace(`${process.env.PUBLIC_URL}/dashboard`);
		} catch (error) {
			console.error("Login failed:", error);
		} finally {
			setLoader(false);
		}
	};

	const items = [];

	// Add quick login if available
	if (
		login &&
		!expired &&
		(canAddTask || canEdit) &&
		(inf.administrator ||
			inf.deviceReadonly ||
			inf.userLimit > 0 ||
			inf.deviceLimit > 0)
	) {
		items.push({
			label: trans("Quick Login"),
			key: "login",
			icon: <CiLogin size={16} />,
		});
	}

	// Add group connections option if provided
	if (onGroupConnect) {
		items.push({
			label: trans("Connections"),
			key: "group-connect",
			icon: (
				<img
					width={18}
					height={18}
					src={`${process.env.PUBLIC_URL}/assets/link.svg`}
					alt="Connections"
				/>
			),
		});
	}

	// Add link option if allowed
	if (type === "link" && (canAddTask || canEdit || canConnections)) {
		items.push({
			label: trans("Connections"),
			key: "link",
			icon: (
				<img
					width={18}
					height={18}
					src={`${process.env.PUBLIC_URL}/assets/link.svg`}
					alt="Connections"
				/>
			),
		});
	}

	if (assignrole === "assignrole" && (canAddTask || canEdit)) {
		items.push({
			label: trans("Assign Role"),
			key: "assignrole",
			icon: (
				<img
					width={18}
					height={18}
					src={`${process.env.PUBLIC_URL}/assets/link.svg`}
					alt="Role"
				/>
			),
		});
	}
	if (type === "projectSetup" && (canAddTask === true || canEdit === true)) {
		items.push({
			label: trans("Continue Setup"),
			key: "continuesetup",
			icon: <ToolOutlined />,
		});
	}
if (
    type === "request" &&
    (canAddTask ||
      inf.administrator === true ||
      inf.deviceReadonly === true ||
      inf.deviceLimit > 0 ||
      inf.userLimit > 0)
  ) {
    items.push({
      label: trans("Create Task"),
      key: "requestTask",
      icon: <PlusOutlined />,
      disabled: request?.status !== "pending",
    });
  }
	  if (onConfigShift) {
    items.push({
      label: trans("Config Shift"),
      key: "configShift",
      icon: <ToolOutlined />,
    });
}
	if (
		onAssignPois &&
		(canEdit || canAddTask || canConnections || canEditPois || canAddPois)
	) {
		items.push({
			label: trans("Assign POIs"),
			key: "assignPois",
			icon: (
				<img
					width={18}
					height={18}
					src={`${process.env.PUBLIC_URL}/assets/link.svg`}
					alt="Assign POIs"
				/>
			),
		});
	}
	if (type === "request" && canEdit) {
		items.push({
			label: trans("Cancel"),
			key: "cancelrequest",
			icon: <StopOutlined />,
			disabled: request?.status !== "pending",
		});
	}
	if (type === "company" && onAssignProjects && (canEdit || canAddTask)) {
		items.push({
			label: trans("Assign Projects"),
			key: "assignProjects",
			icon: <PlusOutlined />,
		});
	}
	if (type === "member" && memberId && (canEdit || canAddTask)) {
		items.push({
			label: trans("Assign to Team"),
			key: "assignMemberToTeams",
			icon: <PlusOutlined />,
		});
		items.push({
			label: trans("Assign Company"),
			key: "assignCompany",
			icon: <PlusOutlined />,
		});
	}
	if (type === "team" && teamId && (canEdit || canAddTask)) {
		items.push({
			label: trans("Assign Members"),
			key: "assignMembersToTeam",
			icon: <PlusOutlined />,
		});
	}

	// ✅ MODIFIED: Add edit based on type
	// For snags, use canEditSnag() to check permissions
	if (type === "snag") {
		if (canEditSnag()) {
			items.push({
				label: trans("Edit"),
				key: "edit",
				icon: <EditOutlined />,
			});
		}
	} else if (irId && type !== "snag") {
		// For IR, only allow edit when status is PENDING_QA
		if (irStatus === "PENDING_QA" || type === "offlineMode") {
			items.push({
				label: trans("Edit"),
				key: "edit",
				icon: <EditOutlined />,
			});
		}
	} else if (
		// For other types, use existing logic
		inf.administrator === true ||
		inf.deviceReadonly === true ||
		inf.deviceLimit > 0 ||
		inf.userLimit > 0 ||
		inf.attributes.role === "contractor" ||
		inf.attributes.role === "qa"
	) {
		items.push({
			label: trans("Edit"),
			key: "edit",
			icon: <EditOutlined />,
			disabled: request && request?.status !== "pending",
		});
	}

	// ✅ MODIFIED: Add delete/deactivate/activate based on type
	// For teams, show "Activate" or "Deactivate" based on status
	if (type === "team" && canDelete) {
		if (teamStatus === "INACTIVE") {
			items.push({
				label: trans("Activate"),
				key: "activate",
				icon: <PlusOutlined />,
			});
		} else {
			items.push({
				label: trans("Deactivate"),
				key: "deactivate",
				icon: <StopOutlined />,
				danger: true,
			});
		}
	} else if (type === "member" && memberId && (canDelete || canEdit)) {
		// For members, show "Activate" or "Deactivate" based on status
		if (memberStatus) {
			items.push({
				label: trans("Activate"),
				key: "activate",
				icon: <PlusOutlined />,
			});
		} else {
			items.push({
				label: trans("Deactivate"),
				key: "deactivate",
				icon: <StopOutlined />,
				danger: true,
			});
		}
	} else if (type === "snag") {
		// For snags, only QA and Consultant can delete
		const userRole = inf?.attributes?.role;
		const canDeleteSnag = userRole === "qa" || userRole === "consultant";

		items.push({
			label: trans("Delete"),
			key: "delete",
			icon: <FaTrash size={14} />,
			disabled: !canDeleteSnag,
			danger: true,
		});
	} else if (
		inf.administrator === true ||
		inf.deviceLimit > 0 ||
		inf.userLimit > 0 ||
		(inf.attributes.role === "contractor" && type === "offlineMode")
	) {
		items.push({
			label: trans("Delete"),
			key: "delete",
			icon: <FaTrash size={14} />,
			disabled:
				request &&
				request?.status !== "pending" &&
				request?.status !== "cancelled",
			danger: true,
		});
	}

	return (
		<>
			{pathname.includes("/notifications/configuration") ||
			pathname.includes("/groups") ||
			pathname.includes("/project-setup") ? (
				<Dropdown
					menu={{ items, onClick: handleMenuClick }}
					className="custom-dropdown-button"
					trigger={["click"]}
				>
					<Button>
						{trans("Actions")}
						<DownOutlined />
					</Button>
				</Dropdown>
			) : (
				<Dropdown.Button
					icon={<DownOutlined />}
					className="custom-dropdown-button"
					menu={{ items, onClick: handleMenuClick }}
					onClick={handleDisplayClick}
				>
					{trans("view")}
				</Dropdown.Button>
			)}
			<Display
				vehicleId={vehicleId}
				DriverId={DriverId}
				userId={userId}
				GroupId={GroupId}
				technicianId={technicianId}
				maintenanceId={maintenanceId}
				formId={formId}
				taskId={taskId}
				poiId={poiId}
				requestId={request?.id}
				permissionId={permissionId}
				roleId={roleId}
				customerId={customerId}
				snagId={snagId}
				irId={irId}
				submittalId={submittalId}
				companyId={companyId}
				teamId={teamId}
				memberId={memberId}
				type={type}
			/>
			<Delete
				vehicleId={vehicleId}
				driverId={DriverId}
				userId={userId}
				GroupId={GroupId}
				notifiyid={notifiyid}
				technicianId={technicianId}
				maintenanceId={maintenanceId}
				formId={formId}
				taskId={taskId}
				poiId={poiId}
				requestId={request?.id}
				permissionId={permissionId}
				customerId={customerId}
				roleId={roleId}
				snagId={snagId}
				irId={irId}
				companyId={companyId}
				teamId={type !== "team" ? teamId : undefined}
			/>
			{type === "team" && (
				<>
					<Modal
						title={trans("Deactivate Team")}
						open={isDeactivateModalVisible}
						onOk={handleDeactivateConfirm}
						onCancel={() => setIsDeactivateModalVisible(false)}
						okText={trans("Deactivate")}
						cancelText={trans("Cancel")}
						okButtonProps={{ danger: true }}
					>
						<p>{trans("Are you sure you want to deactivate this team?")}</p>
					</Modal>
					<Modal
						title={trans("Activate Team")}
						open={isActivateModalVisible}
						onOk={handleActivateConfirm}
						onCancel={() => setIsActivateModalVisible(false)}
						okText={trans("Activate")}
						cancelText={trans("Cancel")}
					>
						<p>{trans("Are you sure you want to activate this team?")}</p>
					</Modal>
				</>
			)}
			{type === "user" && userId && (
				<>
					<Modal
						title={trans("Deactivate User")}
						open={isDeactivateModalVisible}
						onOk={handleDeactivateConfirm}
						onCancel={() => setIsDeactivateModalVisible(false)}
						okText={trans("Deactivate")}
						cancelText={trans("Cancel")}
						okButtonProps={{ danger: true }}
					>
						<p>{trans("Are you sure you want to deactivate this user?")}</p>
					</Modal>
					<Modal
						title={trans("Activate User")}
						open={isActivateModalVisible}
						onOk={handleActivateConfirm}
						onCancel={() => setIsActivateModalVisible(false)}
						okText={trans("Activate")}
						cancelText={trans("Cancel")}
					>
						<p>{trans("Are you sure you want to activate this user?")}</p>
					</Modal>
				</>
			)}
			{type === "member" && memberId && (
				<>
					<Modal
						title={trans("Deactivate Member")}
						open={isDeactivateModalVisible}
						onOk={handleDeactivateConfirm}
						onCancel={() => setIsDeactivateModalVisible(false)}
						okText={trans("Deactivate")}
						cancelText={trans("Cancel")}
						okButtonProps={{ danger: true }}
					>
						<p>{trans("Are you sure you want to deactivate this member?")}</p>
					</Modal>
					<Modal
						title={trans("Activate Member")}
						open={isActivateModalVisible}
						onOk={handleActivateConfirm}
						onCancel={() => setIsActivateModalVisible(false)}
						okText={trans("Activate")}
						cancelText={trans("Cancel")}
					>
						<p>{trans("Are you sure you want to activate this member?")}</p>
					</Modal>
				</>
			)}
		</>
	);
};

export default Actions;
